import { IStatus } from '@dfl/mui-react-common';
import { GRAY, GREEN, RED } from 'settings/theme';
import { BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM } from '../interfaces';

export const BUSINESS_ACCOUNT_REQUEST_STATUS: IStatus[] = [
  { _id: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM.PENDING, title: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM.PENDING, color: GRAY },
  { _id: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM.ACCEPTED, title: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM.ACCEPTED, color: GREEN },
  { _id: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM.REJECTED, title: BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM.REJECTED, color: RED },
];

export const BUSINESS_ACCOUNT_REQUEST_STATUS_MAP = new Map<BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM, IStatus>(
  BUSINESS_ACCOUNT_REQUEST_STATUS.map((status) => [status._id as BUSINESS_ACCOUNT_REQUEST_STATUS_ENUM, status]),
);
